module.exports = "/_next/static/images/f79b2f12120d417cb3b4158907a38e38-hands-holding-cards-md@3x.jpg";